/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_End_LabelInputs */

const en_audio_recorder_end_label = /** @type {(inputs: Audio_Recorder_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End`)
};

const fr_audio_recorder_end_label = /** @type {(inputs: Audio_Recorder_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin`)
};

const de_audio_recorder_end_label = /** @type {(inputs: Audio_Recorder_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ende`)
};

const it_audio_recorder_end_label = /** @type {(inputs: Audio_Recorder_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FINE`)
};

const ru_audio_recorder_end_label = /** @type {(inputs: Audio_Recorder_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конец`)
};

const es_audio_recorder_end_label = /** @type {(inputs: Audio_Recorder_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin`)
};

const zh_cn2_audio_recorder_end_label = /** @type {(inputs: Audio_Recorder_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结尾`)
};

const ja_audio_recorder_end_label = /** @type {(inputs: Audio_Recorder_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終わり`)
};

const hi_audio_recorder_end_label = /** @type {(inputs: Audio_Recorder_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंत`)
};

const pt_pt2_audio_recorder_end_label = /** @type {(inputs: Audio_Recorder_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fim`)
};

/**
* | output |
* | --- |
* | "End" |
*
* @param {Audio_Recorder_End_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_end_label = /** @type {((inputs?: Audio_Recorder_End_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_End_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_end_label(inputs)
	if (locale === "de") return de_audio_recorder_end_label(inputs)
	if (locale === "it") return it_audio_recorder_end_label(inputs)
	if (locale === "ru") return ru_audio_recorder_end_label(inputs)
	if (locale === "es") return es_audio_recorder_end_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_end_label(inputs)
	if (locale === "ja") return ja_audio_recorder_end_label(inputs)
	if (locale === "hi") return hi_audio_recorder_end_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_end_label(inputs)
	return en_audio_recorder_end_label(inputs)
});